/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as Msdyn365 from '@msdyn365-commerce/core';
import { AEM_URL } from '../config';
import { IFooterData } from '../modules/farmlands-footer/farmlands-footer.data';
import axios from 'axios';
import https from 'https';

/**
 * TestingAemCalls Input Action
 */

export class FarmlandsFooterCallsAction implements Msdyn365.IActionInput {
    // TODO: Construct the input needed to run the action
    // constructor() {
    // }
    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => 'header_footer_data';
    public getCacheObjectType = () => 'header_footer_data';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new FarmlandsFooterCallsAction();
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
export async function action(): Promise<IFooterData | null> {
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;

    // TODO: Uncomment the below line to get the value from a service
    // const response = await Msdyn365.sendRequest<ITestingAemCallsData[]>('/get/example/id/1', 'get');
    // return {text: 'Static data from action'};
    // let temp1 = '';
    let data: IFooterData | null = null;
    const instance = axios.create({
        httpsAgent: new https.Agent({
          rejectUnauthorized: false
        })
      });
    await instance.get(`${AEM_URL}/content/portal/nz/en/home/ecomm-api.model.json`,{
        headers: {
            'Content-Type': 'application/json',
        }
    }).then((response) => {
            data = response.data[':items'].root[':items'];
        })
        .catch((error) => {
            console.error(error);
        });
    return data;
}
export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IFooterData>>action,
    input: createInput
});
